module.exports = __webpack_public_path__ + "static/media/github.613b3b9b.png";